export default "__VITE_ASSET__CeR93goc__"